export enum DocumentNotifyTypeEnum {
    InitialDocument = 0,
    VersionUpdate = 1,
    Rescinded = 2,
    Restored = 3,
    Deleted = 4,
    Review = 50
}
